import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useGsap } from "../../animations/hooks";

function HeroSection() {
    const { t } = useTranslation();
    const photo_url = process.env.REACT_APP_SHANDE_PHOTO_URL;

    const heroNoteParts = (t("heroNote") || "")
        .split("·")
        .map((part) => part.trim())
        .filter(Boolean);

    const heroRef = useGsap((gsap, el) => {
        const tl = gsap.timeline({ defaults: { ease: "power3.out" } });
        tl.from(el.querySelector(".landing-tag"), { y: 20, autoAlpha: 0, duration: 0.6 })
          .from(el.querySelectorAll(".landing-hero-title .hero-line"), { y: 40, autoAlpha: 0, duration: 0.9, stagger: 0.12 }, "-=0.3")
          .from(el.querySelector(".landing-hero-desc"), { y: 24, autoAlpha: 0, duration: 0.7 }, "-=0.5")
          .from(el.querySelectorAll(".landing-hero-actions .landing-btn"), { y: 18, autoAlpha: 0, duration: 0.6, stagger: 0.1 }, "-=0.4")
          .from(el.querySelector(".landing-hero-note"), { autoAlpha: 0, duration: 0.6 }, "-=0.3")
          .from(el.querySelector(".landing-hero-img"), { x: 40, scale: 0.94, autoAlpha: 0, duration: 1.1, ease: "power2.out" }, 0.25);

        // Gentle float on the hero image after the entrance finishes.
        gsap.to(el.querySelector(".landing-hero-img"), {
            y: -10,
            duration: 3,
            ease: "sine.inOut",
            yoyo: true,
            repeat: -1,
            delay: tl.duration(),
        });
    });

    return (
        <section ref={heroRef} className="landing-hero">
            <div className="container">
                <div className="landing-hero-grid">
                    <div className="landing-hero-body">
                        <span className="landing-tag">{t("heroTagline")}</span>
                        <h1 className="landing-hero-title">
                            <span className="hero-line">{t("heroTitle1")}</span>
                            <span className="hero-line">{t("heroTitle2")}</span>
                        </h1>
                        <p className="landing-hero-desc">{t("heroDescription")}</p>
                        <div className="landing-hero-actions">
                            <Link className="landing-btn landing-btn-primary" to="/donate">{t("heroCta1")}</Link>
                            <Link className="landing-btn landing-btn-ghost" to="/donationDetails">{t("heroCta2")}</Link>
                        </div>
                        <p className="landing-hero-note">
                            {heroNoteParts.map((part, index) => (
                                <span className="landing-hero-note-part" key={index}>{part}</span>
                            ))}
                        </p>
                    </div>
                    <div className="landing-hero-media">
                        <img
                            className="landing-hero-img"
                            src={photo_url + "homepage/charityRun.png"}
                            alt="Hope Run charity run"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
export default HeroSection;
